import _ from "lodash";
import {
  FETCH_CLIENT,
  FETCH_CLIENT_DONE,
  FETCH_CLIENT_ERROR,
  FETCH_GEO_LOCATION,
  FETCH_GEO_LOCATION_DONE,
  FETCH_GEO_LOCATION_ERROR,
  FETCH_CLIENT_BRANDING,
  FETCH_CLIENT_BRANDING_DONE,
  FETCH_CLIENT_BRANDING_ERROR,
  FETCH_CLIENT_NETWORK,
  FETCH_CLIENT_NETWORK_DONE,
  FETCH_CLIENT_NETWORK_ERROR,
  LOCATION_ALLOW_BLOCK
} from "./constants";

const initialState = {
  client: {},
  clientBranding: {},
  clientNetwork: [],
  location: null,
  error: "",
  isLocationAllowed: false,
  isFetching: false,
  isFetchingLocation: false,
  isFetchingBranding: false,
  isFetchingNetwork: false
};

const sortRemoveDuplicates = (collection, unique, sort) =>
  _.sortBy(
    _.uniqBy(collection, (c) => c[unique]),
    (c) => c[sort]
  );

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CLIENT:
      return {
        ...state,
        client: {},
        error: "",
        isFetching: true
      };
    case FETCH_GEO_LOCATION:
      return {
        ...state,
        location: null,
        error: "",
        isFetchingLocation: true
      };
    case FETCH_CLIENT_BRANDING:
      return {
        ...state,
        clientBranding: {},
        error: "",
        isFetchingBranding: true
      };
    case FETCH_CLIENT_NETWORK:
      return {
        ...state,
        clientNetwork: [],
        error: "",
        isFetchingNetwork: true
      };
    case FETCH_CLIENT_DONE: {
      const { data } = payload;
      data.siblings = sortRemoveDuplicates(data.siblings, "id", "clientName");
      data.children = sortRemoveDuplicates(data.children, "id", "clientName");
      data.grandchildren = sortRemoveDuplicates(
        data.grandchildren,
        "id",
        "clientName"
      );
      return {
        ...state,
        client: data,
        isFetching: false
      };
    }
    case FETCH_GEO_LOCATION_DONE: {
      return {
        ...state,
        location: { ...payload },
        isFetchingLocation: false
      };
    }
    case FETCH_CLIENT_BRANDING_DONE: {
      return {
        ...state,
        clientBranding: payload,
        isFetchingBranding: false
      };
    }
    case FETCH_CLIENT_NETWORK_DONE: {
      return {
        ...state,
        clientNetwork: payload,
        isFetchingNetwork: false
      };
    }
    case FETCH_CLIENT_ERROR:
      return {
        ...state,
        client: {},
        error: "There was an error fetching the client",
        isFetching: false
      };
    case FETCH_GEO_LOCATION_ERROR:
      return {
        ...state,
        location: null,
        error: "There was an error getting client IP",
        isFetchingLocation: false
      };
    case FETCH_CLIENT_BRANDING_ERROR:
      return {
        ...state,
        clientBranding: {},
        error: "There was an error fetching client branding",
        isFetchingBranding: false
      };
    case FETCH_CLIENT_NETWORK_ERROR:
      return {
        ...state,
        clientNetwork: [],
        error: "There was an error fetching client network",
        isFetchingNetwork: false
      };
    case LOCATION_ALLOW_BLOCK:
      return {
        ...state,
        isLocationAllowed: payload
      };
    default:
      return state;
  }
};
